import { ButtonGroup, useBreakpointValue } from "@chakra-ui/react";
import React from "react";
import Button from "../../shared/components/ui/Button";
import { SharedCurrentUser } from "../../shared/lib/types";
import useRequest from "../../shared/lib/useRequest";
import { currentPostThemePath } from "../../../../routes";
import useFlash from "../../shared/lib/useFlash";
import SimpleViewIcon from "../../shared/components/icons/SimpleViewIcon";
import DetailedViewIcon from "../../shared/components/icons/DetailedViewIcon";

const ChangeThemeButtons = ({
  currentUser,
}: {
  currentUser: SharedCurrentUser;
}) => {
  const theme =
    currentUser?.current_post_theme_name ??
    localStorage.getItem("current_post_theme_name") ??
    "detail";

  const compactButtonVariant = theme === "compact" ? "solid" : "outline";
  const detailButtonVariant = theme === "detail" ? "solid" : "outline";
  const request = useRequest();
  const showFlash = useFlash();

  const showText = useBreakpointValue({ base: false, md: true });

  const createButtonOnClick = (themeName: string) => {
    if (theme === themeName) return undefined;

    if (currentUser != null) {
      return async () => {
        const res = await request(currentPostThemePath(), "PUT", {
          name: themeName,
        });
        if (res.ok) {
          location.reload();
        } else {
          showFlash({ error: "もう一度お試しください" });
        }
      };
    } else {
      return () => {
        localStorage.setItem("current_post_theme_name", themeName);
        location.reload();
      };
    }
  };

  return (
    <ButtonGroup isAttached display={"flex"} flexGrow={1}>
      <Button
        fontSize="xs"
        px={2}
        py={1}
        variant={compactButtonVariant}
        onClick={createButtonOnClick("compact")}
        flexGrow={1}
        lineHeight={1}
        aria-label="簡易表示"
      >
        {showText ? "簡易表示" : <SimpleViewIcon boxSize={4} />}
      </Button>
      <Button
        fontSize="xs"
        variant={detailButtonVariant}
        px={2}
        py={1}
        onClick={createButtonOnClick("detail")}
        flexGrow={1}
        lineHeight={1}
        aria-label="詳細表示"
      >
        {showText ? "詳細表示" : <DetailedViewIcon boxSize={4} />}
      </Button>
    </ButtonGroup>
  );
};

export default ChangeThemeButtons;
